export const staticPaths = ['/password/reset', '/password/reset/success', '/password/update', '/password/update/success']